import store from '@/store'
import network from '@/utils/network'
import { customerPath } from '@/utils/api'

/**
 * Récupère un événement de l'agence
 * @returns {Promise<>}
 */
export const getAgencyEvent = async (reference) => {
  const slugAgency = store.getters['user/agencySlug']
  const r = await network.get(`agency/${slugAgency}${customerPath()}/event/${reference}`)
  return r.data
}

/**
 * Enregistre un événement de l'agence
 * @returns {Promise<>}
 */
export const postAgencyEvent = async (event) => {
  const slugAgency = store.getters['user/agencySlug']
  const r = await network.post(`agency/${slugAgency}/event`, event)
  return r.data
}

/**
 * Transmettre un évènement PTI
 * @param event
 * @return {Promise<>}
 */
export const postAgencyEventPti = async (event) => {
  const slugAgency = store.getters['user/agencySlug']
  const r = await network.post(`agency/${slugAgency}/event-pti`, event)
  return r.data
}

/**
 * Supression un évènement
 * @param event
 * @return {Promise<>}
 */
export const deleteAgencyEvent = async (event) => {
  const slugAgency = store.getters['user/agencySlug']
  const r = await network.delete(`agency/${slugAgency}/event/${event.reference}`, event)
  return r.data
}
